import { useState } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core';
import CustomModal from '../customModal';
import ListWithTooltip from '../listWithTooltip';
import PeoplePicker from '../peoplePicker';
import { getFormattedUsers, isArrayEmpty } from '../../../utility/helpers';

const useStyles = makeStyles(({ palette: { primary }, spacing }) => ({
  reviewers: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: 237,
    maxHeight: '100%',
  },
  usersToReviewWrapper: {
    marginTop: spacing(6),
  },
  listLabel: {
    color: primary.bluish1,
    lineHeight: '18px',
    marginBottom: spacing(2),
  },
  userMoreItems: {
    backgroundColor: 'transparent',
    fontSize: 16,
    lineHeight: '20px',
    padding: spacing(0, 2),
    marginTop: spacing(0.5),
    maxWidth: 'fit-content',
  },
}));

const AddReviewersDialog = ({
  translations,
  reviewers = [],
  existingReviewers = [],
  usersToReview = [],
  users,
  isOpened,
  isScheduled,
  onAdd,
  onClose,
  onConfirm,
}) => {
  const classes = useStyles();

  const [parentNode, setParentNode] = useState(null);

  return (
    <CustomModal
      title={isScheduled ? translations.titleSchedule : translations.title}
      description={
        isScheduled
          ? translations.descriptionSchedule
          : translations.description
      }
      closeButtonLabel={translations.close}
      confirmButtonLabel={
        isScheduled ? translations.confirmSchedule : translations.confirm
      }
      isConfirmDisabled={isArrayEmpty(reviewers)}
      isOpened={isOpened}
      onClose={onClose}
      onConfirm={onConfirm}
      isMedium
    >
      <div>
        <div ref={setParentNode} className={classes.reviewers}>
          <PeoplePicker
            parentNode={parentNode}
            translations={translations.fieldLabels}
            preselectedUsers={reviewers}
            options={users}
            blacklistedUsers={existingReviewers}
            onSelect={onAdd}
            formattedUsers={getFormattedUsers(users, true)}
            shouldCalculateSelectionHeight
            hasSelectAll
            showSelection
            showDirectReports
          />
        </div>
        {!isArrayEmpty(usersToReview) && (
          <div className={classes.usersToReviewWrapper}>
            <ListWithTooltip
              labelClass={classes.listLabel}
              moreItemsClass={classes.userMoreItems}
              label={translations.usersToReview}
              items={usersToReview}
              asyncListProps={{
                position: 'top',
              }}
              isUserList
            />
          </div>
        )}
      </div>
    </CustomModal>
  );
};

AddReviewersDialog.propTypes = {
  translations: PropTypes.object.isRequired,
  isOpened: PropTypes.bool.isRequired,
  usersToReview: PropTypes.arrayOf(PropTypes.shape({})),
  reviewers: PropTypes.arrayOf(PropTypes.shape({})),
  users: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  isScheduled: PropTypes.bool.isRequired,
  existingReviewers: PropTypes.arrayOf(PropTypes.number),
  onAdd: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};
export default AddReviewersDialog;
